<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system/index';
	import IrrigationCard from 'src/components/XT1/Irrigation/IrrigationCard.svelte';
	import IrrigationZoneController from 'src/components/XT1/Irrigation/IrrigationZoneController.svelte';
	import IrrigationCardSequences from 'src/components/XT1/Irrigation/IrrigationCardSequences.svelte';
	import IrrigationQuickStartTourV2 from './IrrigationQuickStartTourV2.svelte';
	import IrrigationWeatherMonitor from 'src/components/XT1/Irrigation/IrrigationWeatherMonitor.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	interface IrrigationInterface extends Device {
		quick_tour_guide?: boolean;
	}

	export let device: IrrigationInterface, statuses: VCInterfaceStatus[];

	$: zones = statuses.filter((i) => /^(zone\d)$/.test(i?.role));
	$: sequences = statuses.find((i) => i.role === 'active_sequence');
	$: temperature = statuses.find((i) => i.role === 'average_temperature');
	$: precipitation = statuses.find((i) => i.role === 'last_precipitation');
</script>

<DeviceNotificationLabel deviceId={device?.id} />
<div class="irrigation-container">
	<div class="d-flex flex-direction-column">
		<!-- hide Weather Monitor if weather_api is disabled -->
		{#if !temperature?.hideLabel}
			<IrrigationCard
				title={$format('irrigation_weather_monitor_title', {
					default: 'Weather Monitor',
				})}
				icon="fas fa-cloud-sun"
			>
				<IrrigationWeatherMonitor {temperature} {precipitation} />
			</IrrigationCard>
		{/if}
		{#if !device?.quick_tour_guide}
			<IrrigationCard
				title={$format('irrigation_active_sequence_title', {
					default: 'Active Sequence',
				})}
				icon="far fa-network-wired"
			>
				<IrrigationQuickStartTourV2 {device} />
			</IrrigationCard>
		{:else if sequences?.config?.options?.length === 1}
			<IrrigationCard
				title={$format('irrigation_active_sequence_title', {
					default: 'Active Sequence',
				})}
				icon="far fa-network-wired"
			>
				<Alert
					isHeadingBold
					heading={$format('irrigation_sequence_info_heading', {
						default: 'Sequence Info',
					})}
					message={$format('irrigation_no_sequence_message', {
						default: 'No sequences created. Tap below to create your first sequence.',
					})}
					cta={{
						title: $format('irrigation_create_sequence', {
							default: 'Create a sequence',
						}),
					}}
					on:cta_click={() => navigateToSetting(device.id, 'irrigation_sequences')}
				/>
			</IrrigationCard>
		{:else if sequences?.event === 'none'}
			{#if sequences?.config?.options?.length > 1}
				<IrrigationCard
					title={$format('irrigation_active_sequence_title', {
						default: 'Active Sequence',
					})}
					icon="far fa-network-wired"
				>
					<Alert
						isHeadingBold
						heading={$format('irrigation_sequence_info_heading', {
							default: 'Sequence Info',
						})}
						message={$format('irrigation_no_active_sequence_message', {
							default: 'No active sequence. Tap below to start one.',
						})}
						cta={{
							title: $format('irrigation_start_sequence', {
								default: 'Start a Sequence',
							}),
						}}
						on:cta_click={() => navigateToSetting(device.id, 'irrigation_sequences')}
					/>
				</IrrigationCard>
			{/if}
		{/if}
		{#if sequences?.event === 'none'}
			{#each zones as zone}
				<IrrigationZoneController {device} {zone} />
			{/each}
		{:else}
			<IrrigationCardSequences {device} {sequences} {zones} />
		{/if}
	</div>
</div>

<style>
	.irrigation-container {
		background-color: #0e0f10;
		border-radius: 18px;
		padding: 8px;
	}
</style>
